import React from "react";

const UnFocusCall = () => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.9555 9.85969C2.90104 18.9142 20.78 37.6737 30.275 28.1787C31.1121 27.3416 30.8127 26.9983 30.1571 26.3427L28.5872 24.7728C27.9144 24.1 26.976 23.1216 26.1168 23.9808C25.2576 24.84 25.5284 25.8548 25.5284 25.8548C20.5153 30.8257 8.96019 19.2415 13.9584 14.2846C13.9584 14.2846 14.9531 14.5755 15.8123 13.7163C16.6714 12.8571 16.4594 12.645 15.7866 11.9722L14.1304 10.316C13.4576 9.64317 12.8147 9.00054 11.9555 9.85969Z"
        fill="#4BC285"
      />
      <path
        d="M18 16C17.4477 16 17 16.4477 17 17C17 17.5523 17.4477 18 18 18H28C28.5523 18 29 17.5523 29 17C29 16.4477 28.5523 16 28 16H18Z"
        fill="#4BC285"
      />
      <path
        d="M24 12C24 11.4477 23.5523 11 23 11C22.4477 11 22 11.4477 22 12V22C22 22.5523 22.4477 23 23 23C23.5523 23 24 22.5523 24 22V12Z"
        fill="#4BC285"
      />
    </svg>
  );
};

export default UnFocusCall;
